import React, {useEffect, useRef, useState} from 'react'
import {TOURNAMENTSYSTEMS} from "../../../constants/tournamentSystems";
import {Button} from "primereact/button";
import FetchUtil from "../../../util/FetchUtil";
import ConfigUtil from "../../../util/ConfigUtil";
import ConfirmDialog from "../../general/ConfirmDialog";
import {ToggleButton} from "primereact/togglebutton";
import TournamentPlayerEventOperatorSelectDialog from "./TournamentPlayerEventOperatorSelectDialog";
import {Fieldset} from "primereact/fieldset";
import ErrorInfoComponent from "../../general/ErrorInfoComponent";
import DHDialog from "../../general/DHDialog";
import DHSelectionComponent from "../../general/DHSeclectionCompontent";
import LigaTeilnehmerFilterArea from "../liga/LigaTeilnehmerFilterArea";
import DHTextField from "../../general/DHTextField";
import DHSwitch from "../../general/DHSwitch";
import DHButtonSave from "../../general/DHButtonSave";

export default function TurnierPlayerDialog({tournament, isAdmin, onClose, onRefresh}) {

    const nameInput = useRef(null);

    const [infoMessage, setInfoMessage] = useState(undefined);
    const [errorMessage, setErrorMessage] = useState(undefined);

    const [filterText, setFilterText] = React.useState("");
    const [filterBezahlt, setFilterBezahlt] = React.useState(undefined);
    const [filterWarteliste, setFilterWarteliste] = React.useState(false);
    const [filterAnwesend, setFilterAnwesend] = React.useState(undefined);

    let [eingabe, setEingabe] = useState("");
    let [spielerid, setSpielerid] = useState("");
    let [spielerIdDoppel, setSpielerIdDoppel] = useState(undefined);
    let [spielerIdSingle1, setSpielerIdSingle1] = useState(undefined);
    let [spielerIdSingle2, setSpielerIdSingle2] = useState(undefined);
    let [bezahlt, setBezahlt] = useState(false);
    let [anwesend, setAnwesend] = useState(false);
    let [heimmannschaft, setHeimmannschaft] = useState(false);
    let [selectedPlayer, setSelectedPlayer] = useState(undefined);
    let [kratzerPoints, setKratzerPoints] = useState([]);
    let [showDeleteDialog, setShowDeleteDialog] = useState(false);
    let [showSearchDialog, setShowSearchDialog] = useState(false);
    let [showDoppeltTournamentSearchDialog, setShowDoppeltTournamentSearchDialog] = useState(false);
    let [kratzerPointId, setKratzerPointId] = useState(undefined);
    let [showSearchDialogFuerSpielerIdSingle1, setShowSearchDialogFuerSpielerIdSingle1] = useState(false);
    let [showSearchDialogFuerSpielerIdSingle2, setShowSearchDialogFuerSpielerIdSingle2] = useState(false);

    let [showZuordnungArea, setShowZuorndungArea] = useState(false);

    let [workingBySpielerId, setWorkingBySpielerId] = useState(false);
    let [workingByName, setWorkingByName] = useState(false);


    useEffect(() => {
        if (!isKratzerTurnier()) {
            return;
        }
        // Bei Kratzer müssen die Kratzerpunkte geladen werden.
        FetchUtil.fetchGet(ConfigUtil.getConfig().resourceUrls.tournament + "/kratzerpoints/load/" + tournament.id,
            json => {
                setKratzerPoints([...json]);
            },
            responseNotOk => {
                setErrorMessage("Fehler beim Laden der Kratzer: " + responseNotOk.message);
            },
            error => {
                setErrorMessage("Fehler beim Laden der Kratzer: " + error.message);
            }
        );
    }, []);

    const isKratzerTurnier = () => {
        return tournament.turniersystem === TOURNAMENTSYSTEMS.KRATZER.id;
    }

    const isLigaspieltag = () => {
        return tournament.turniersystem === TOURNAMENTSYSTEMS.LIGASPIELTAG.id;
    }

    const isEventOperator = () => {
        return tournament.eventOperatorId !== null && tournament.eventOperatorId !== undefined;
    }


    const handelKeyDownSpielerId = (e) => {
        if (e.keyCode === 13) {
            // enter
            saveBySpielerID();
        }
    }

    const handelKeyDownSpielerName = (e) => {
        if (e.keyCode === 13) {
            // enter
            saveByName();
        }
    }

    const saveBySpielerID = () => {
        setErrorMessage(undefined);
        if (spielerid === "" || spielerid.trim() === "") {
            setErrorMessage("SpielerId muss gefüllt sein.");
            return;
        }
        if (isKratzerTurnier() && kratzerPointId === undefined) {
            setErrorMessage("Kratzer müssen ausgewählt werden.");
            return;
        }
        setWorkingBySpielerId(true);
        let data = {
            tournamentId: tournament.id, idShort: spielerid, tournamentKratzerPointsId: kratzerPointId ? kratzerPointId : undefined,
            idShortSinglePlayer1: spielerIdSingle1, idShortSinglePlayer2: spielerIdSingle2, idShortDoppel: spielerIdDoppel,
            bezahlt: bezahlt, anwesend: anwesend, heimmannschaft: heimmannschaft
        };
        FetchUtil.fetchPost(ConfigUtil.getConfig().resourceUrls.tournament + "/tournamentteilnehmenIdShort",
            data,
            json => {
                setSelectedPlayer(undefined);
                setEingabe("");
                setSpielerid("");
                setKratzerPointId(undefined);
                setBezahlt(false);
                setAnwesend(false);
                setSpielerIdSingle1(undefined);
                setSpielerIdSingle2(undefined);
                setSpielerIdDoppel(undefined);
                setInfoMessage("Spieler wurde erfolgreich gespeichert.");
                onRefresh();
                setWorkingBySpielerId(false);
            },
            responseNotOk => {
                setErrorMessage("Fehler beim Speichern: " + responseNotOk.message);
                setWorkingBySpielerId(false);
            },
            error => {
                setErrorMessage("Fehler beim Speichern: " + error.message);
                setWorkingBySpielerId(false);
            }
        );
    }

    const saveByName = () => {
        setErrorMessage(undefined);
        if (eingabe === "" || eingabe.trim() === "") {
            setErrorMessage("Spielername muss gefüllt sein.");
            return;
        }
        if (isKratzerTurnier() && !kratzerPointId) {
            setErrorMessage("Kratzer müssen ausgewählt werden.");
            return;
        }
        setWorkingByName(true);
        let id = tournament.id;
        let playerId = selectedPlayer !== undefined ? selectedPlayer.id : undefined;
        let data = {
            tournamentId: id, playerId: playerId, name: eingabe,
            tournamentKratzerPointsId: kratzerPointId !== undefined ? kratzerPointId : undefined,
            idShortSinglePlayer1: spielerIdSingle1, idShortSinglePlayer2: spielerIdSingle2, idShortDoppel: spielerIdDoppel,
            bezahlt: bezahlt, anwesend: anwesend, heimmannschaft: heimmannschaft
        };
        FetchUtil.fetchPost(ConfigUtil.getConfig().resourceUrls.tournament + "/saveplayer",
            data,
            json => {
                setSelectedPlayer(undefined);
                setEingabe("");
                setKratzerPointId(undefined);
                setBezahlt(false);
                setAnwesend(false);
                setSpielerIdSingle1(undefined);
                setSpielerIdSingle2(undefined);
                setSpielerIdDoppel(undefined);
                setInfoMessage("Spieler wurde erfolgreich gespeichert.");
                onRefresh();
                setWorkingByName(false);
                if( nameInput && nameInput.current ) {
                    nameInput.current.focus();
                }
            },
            responseNotOk => {
                setErrorMessage("Fehler beim Speichern: " + responseNotOk.message);
                setWorkingByName(false);
            },
            error => {
                setErrorMessage("Fehler beim Speichern: " + error.message);
                setWorkingByName(false);
            }
        );
    }

    const deletePlayer = () => {
        setErrorMessage(undefined);
        let data = {tournamentId: tournament.id, playerId: selectedPlayer.id};
        FetchUtil.fetchPost(ConfigUtil.getConfig().resourceUrls.tournament + "/deleteplayer",
            data,
            json => {
                setSelectedPlayer(undefined);
                setShowDeleteDialog(false);
                setInfoMessage("Spieler wurde erfolgreich gelöscht.");
                onRefresh();
            },
            responseNotOk => {
                setErrorMessage("Fehler beim Löschen: " + responseNotOk.message);
                setShowDeleteDialog(false);
            },
            error => {
                setErrorMessage("Fehler beim Löschen: " + error.message);
                setShowDeleteDialog(false);
            }
        );
    }

    const getAnzahlSpieler = () => {
        if (tournament === undefined || tournament === null || tournament.tournamentPlayerEntities === undefined || tournament.tournamentPlayerEntities === null) {
            return 0;
        }
        return tournament.tournamentPlayerEntities.length;
    }

    const getKratzerPunkte = (playerId, kratzerPointId) => {
        if (kratzerPointId === null || kratzerPointId === undefined) {
            return "";
        }
        let tmp = kratzerPoints.filter(k => k.id === kratzerPointId)[0];
        if (tmp === null || tmp === undefined) {
            return "";
        }
        return " (" + tmp.bezeichnung + " - Punkte: " + tmp.punkte + ")";
    }

    function getPlayername(row) {
        if (tournament.doppelturnier) {
            return row.name;
        } else {
            let nachname = row.nachname !== null && row.nachname !== undefined ? " , Name: " + row.nachname : "";
            let vorname = row.vorname !== null && row.vorname !== undefined ? " , Vorname: " + row.vorname : "";
            let returnName = row.name + nachname + vorname;
            return returnName;
        }
    }

    const isFilterTeilnehmerAktiv = () => {
        return filterText !== "" || filterBezahlt !== undefined || filterAnwesend !== undefined || filterWarteliste;
    }

    const getRows = () => {
        if (tournament === undefined || tournament === null || tournament.tournamentPlayerEntities === undefined || tournament.tournamentPlayerEntities === null) {
            return "";
        }
        let players = tournament.tournamentPlayerEntities;

        let rows = [];
        for (let i = 0; i < players.length; i++) {
            let modulo = i % 2;
            let currentStyle = modulo === 0 ? {backgroundColor: "#f2f2f2"} : {};
            let player = players[i];
            let zufuegenAufgrundVonName = true;
            let zufuegenAufgrundVonIdShort = true;
            let zufuegenAufgrundVonBezahlt = true;
            let zufuegenAufgrundVonAnwesend = true;
            let zufuegenAufgrundVonWarteliste = true;
            if( filterText !== "") {
                zufuegenAufgrundVonName = getPlayername(player).toUpperCase().includes(filterText.toUpperCase());
                if( !player.idShort.toUpperCase().includes(filterText.toUpperCase())) {
                    zufuegenAufgrundVonIdShort = false;
                }
            }
            if( filterBezahlt !== undefined) {
                if( filterBezahlt === "ja" && !player.bezahlt) {
                    zufuegenAufgrundVonBezahlt = false;
                } else if( filterBezahlt === "nein" && player.bezahlt) {
                    zufuegenAufgrundVonBezahlt = false;
                }
            }
            if( filterAnwesend !== undefined) {
                if( filterAnwesend === "ja" && !player.anwesend) {
                    zufuegenAufgrundVonAnwesend = false;
                } else if( filterAnwesend === "nein" && player.anwesend) {
                    zufuegenAufgrundVonAnwesend = false;
                }
            }
            if( filterWarteliste && !player.warteliste ) {
                zufuegenAufgrundVonWarteliste = false;
            }

            if( (zufuegenAufgrundVonName || zufuegenAufgrundVonIdShort ) && zufuegenAufgrundVonBezahlt && zufuegenAufgrundVonAnwesend && zufuegenAufgrundVonWarteliste ) {
                rows.push(<div className="grid" style={{marginTop: "5px", ...currentStyle}}>
                    <div className="col-fixed" style={{width: "30px"}}>{i + 1}.</div>
                    <div className="col-fixed" style={{width: "50px"}}>
                        <Button icon="pi pi-trash"
                                onClick={(e) => {
                                    setShowDeleteDialog(true);
                                    setSelectedPlayer(player);
                                    setEingabe("");
                                    setBezahlt(false);
                                    setAnwesend(false);
                                    setHeimmannschaft(true);
                                    setSpielerid("");
                                }}
                                style={{marginRight: "5px"}}/>
                    </div>
                    <div className="col" style={{width: "100%", cursor: "pointer"}} onClick={() => {
                        setSelectedPlayer(player);
                        setEingabe(player.name);
                        setBezahlt(player.bezahlt);
                        setAnwesend(player.anwesend);
                        setHeimmannschaft(player.heimmannschaft);
                        setSpielerIdSingle1(player.idShortSinglePlayer1 === null ? undefined : player.idShortSinglePlayer1);
                        setSpielerIdSingle2(player.idShortSinglePlayer2 === null ? undefined : player.idShortSinglePlayer2);
                        setSpielerIdDoppel(player.idShortDoppel === null ? undefined : player.idShortDoppel);
                        setKratzerPointId(player.tournamentKratzerPointsId);
                    }}>
                        <img style={{height: 30, marginRight: 20}} src={player.bezahlt ? "/images/euro_green.png" : "/images/euro_black.png"} alt="Bezahlung"/>
                        {isEventOperator() && <img style={{height: 20, marginRight: 20}} src={player.anwesend ? "/images/anwesend_color.png" : "/images/anwesend_black.png"} alt="Anwesend"/>}
                        {getPlayername(player)}<span style={{marginLeft: 10, marginRight: 10}}>SpielerId: {player.idShort}</span>{getKratzerPunkte(player.id, player.tournamentKratzerPointsId)}
                        {isLigaspieltag() &&
                            <span style={{marginLeft: 10, marginRight: 10}}>{player.heimmannschaft ? "-Heim-" : "-Gast-"}</span>
                        }
                        {player.idShortDoppel !== null && player.idShortDoppel !== undefined && <>
                            <br/><span style={{marginLeft: 10, marginRight: 10}}>Zuordnung Doppel - SpielerId: {player.idShortDoppel}</span>
                        </>
                        }
                        {player.idShortSinglePlayer1 !== null && player.idShortSinglePlayer1 !== undefined && <>
                            <br/><span style={{marginLeft: 10, marginRight: 10}}>Zuordnung Einzel - SpielerId: {player.idShortSinglePlayer1}</span>
                        </>
                        }
                        {player.idShortSinglePlayer2 !== null && player.idShortSinglePlayer2 !== undefined && <>
                            <br/><span style={{marginLeft: 10, marginRight: 10}}>Zuordnung Einzel - SpielerId: {player.idShortSinglePlayer2}</span>
                        </>
                        }
                    </div>
                </div>);
            }
        }
        return rows;
    }

    const getPlayersArea = () => {
        return <>
            <LigaTeilnehmerFilterArea isAdmin={isAdmin} filterText={filterText} filterBezahlt={filterBezahlt} filterAnwesend={filterAnwesend}
                                      filterWarteliste={filterWarteliste} onFilterText={(text) => setFilterText(text)}
                                      onFilterBezahlt={(value) => setFilterBezahlt(value)} onFilterAnwesend={(value) => setFilterAnwesend(value)}
                                      onFilterWarteliste={(value) => setFilterWarteliste(value)}/>
            <div className="grid" style={{marginTop: "10px"}}>
                <div className="col" style={{fontWeight: "bold"}}>Bereits angelegte Spieler
                    ({getAnzahlSpieler()}):
                    {isFilterTeilnehmerAktiv() &&
                        <span style={{marginLeft:10}}>Gefiltert: {getRows().length}</span>
                    }
                </div>
            </div>
            {getRows()}
        </>
    }

    const getNewPlayerArea = () => {
        return <>
            {tournament.eventOperatorId !== null && tournament.eventOperatorId !== undefined &&
                <div className="grid" style={{marginBottom: 20}}>
                    <div className="col">
                        <Button label="Vorhandenen Spieler suchen und auswählen" icon="pi pi-search-plus"
                                onClick={() => setShowSearchDialog(true)}/>
                    </div>
                </div>
            }
            <div style={{marginBottom: 10, display: "flex", alignItems: "center"}}>
                <DHTextField id="id-spieler-id" value={spielerid} onChange={(text) => setSpielerid(text)} required={false}
                             onKeyDown={(e) => handelKeyDownSpielerId(e)}
                             label={"SpielerId"} width={300}/>
                <DHButtonSave label="Speichern" disabled={spielerid.length === 0} working={workingBySpielerId} onClick={() =>saveBySpielerID()}/>
                <Button icon="pi pi-file-o"
                        tooltip="Reset Eingabe"
                        onClick={(e) => {
                            setSelectedPlayer(undefined);
                            setSpielerid("");
                            setEingabe("");
                            setBezahlt(false);
                            setAnwesend(false);
                            setSpielerIdSingle1(undefined);
                            setSpielerIdSingle2(undefined);
                        }}
                        style={{marginLeft: "5px"}}/>

            </div>
            <div style={{marginBottom: 10, display: "flex", alignItems: "center"}}>
                {tournament.doppelturnier && !tournament.dyp &&
                    <DHTextField id="id-name" value={eingabe} onChange={(text) => setEingabe(text)} required={false}
                                 onKeyDown={(e) => handelKeyDownSpielerName(e)}
                                 label={selectedPlayer !== undefined ? "Doppelname ändern" : "Doppelname"} width={300}/>
                }
                {(!tournament.doppelturnier || tournament.dyp) &&
                    <DHTextField id="id-name" value={eingabe} onChange={(text) => setEingabe(text)} required={false}
                                 onKeyDown={(e) => handelKeyDownSpielerName(e)}
                                 label={selectedPlayer !== undefined ? "Person ändern" : "Neue Person"} width={300}/>
                }
                <DHButtonSave label="Speichern" disabled={eingabe.length === 0} working={workingByName} onClick={() =>saveByName()}/>
                <Button icon="pi pi-file-o"
                        tooltip="Reset Eingabe"
                        onClick={(e) => {
                            setSelectedPlayer(undefined);
                            setEingabe("");
                            setSpielerid("");
                            setBezahlt(false);
                            setAnwesend(false);
                            setSpielerIdSingle1(undefined);
                            setSpielerIdSingle2(undefined);
                        }}
                        style={{marginLeft: "5px"}}/>
            </div>
            {!isLigaspieltag() &&
                <div>
                    <DHSwitch id={"id-bezahlt"} label="Bezahlt" value={bezahlt} onChange={(value) => setBezahlt(value)} />
                </div>
            }
            {!isLigaspieltag() && isEventOperator() &&
                <div>
                    <DHSwitch id={"id-anwesend"} label="Anwesend" value={anwesend} onChange={(value) => setAnwesend(value)} />
                </div>
            }
            <div style={{marginTop: 10, marginBottom: 10, cursor: "pointer"}} onClick={() => setShowZuorndungArea(!showZuordnungArea)}>
                <img src="/images/pfeil_rechts_rot_transparent.png" style={{height: 10, marginRight: 5}}/>{showZuordnungArea ? "Verberge " : "Zeige "} Spielerzuordnungsbereich bzgl. Boardvergabe...
            </div>
            {showZuordnungArea && tournament.doppelturnier && tournament.eventOperatorId !== null && tournament.eventOperatorId !== undefined && <div>
                <hr/>
                <div style={{marginBottom: 5, fontWeight: "bold"}}>Hinweis beachten...</div>
                <div style={{marginBottom: 5}}>Auswahl SpielerId für die Einzelspieler ist nur notwendig, wenn die Boardvergabe genutzt werden soll. Damit wird ausgeschlossen, dass ein Spieler
                    gleichzeitig doppelt aufgerufen wird.
                </div>
                <div style={{display: "flex", margin: "auto", verticalAlign: "middle", alignItems: "center", marginBottom: 10}}>
                    <span style={{width: 150}}>SpielerId - Spieler1:</span>
                    {spielerIdSingle1 !== undefined ? <>
                            {spielerIdSingle1}
                            <Button icon="pi pi-trash" style={{marginLeft: 10}}
                                    onClick={() => setSpielerIdSingle1(undefined)}/>
                        </>
                        :
                        <Button label="Spieler auswählen" icon="pi pi-search-plus"
                                onClick={() => setShowSearchDialogFuerSpielerIdSingle1(true)}/>
                    }
                </div>
                <div style={{display: "flex", margin: "auto", verticalAlign: "middle", alignItems: "center", marginBottom: 10}}>
                    <span style={{width: 150}}>SpielerId - Spieler2:</span>
                    {spielerIdSingle2 !== undefined ? <>
                            {spielerIdSingle2}
                            <Button icon="pi pi-trash" style={{marginLeft: 10}}
                                    onClick={() => setSpielerIdSingle2(undefined)}/>
                        </>
                        :
                        <Button label="Spieler auswählen" icon="pi pi-search-plus"
                                onClick={() => setShowSearchDialogFuerSpielerIdSingle2(true)}/>
                    }
                </div>
                <hr/>
            </div>}
            {showZuordnungArea && !tournament.doppelturnier && tournament.eventOperatorId !== null && tournament.eventOperatorId !== undefined && <div>
                <hr/>
                <div style={{marginBottom: 5, fontWeight: "bold"}}>Hinweis beachten...</div>
                <div style={{marginBottom: 5}}>Zuordnung eines Einzelspielers zu einem Doppelpartner ist nur notwendig, wenn die Boardvergabe genutzt werden soll. Damit wird ausgeschlossen, dass ein
                    Spieler gleichzeitig doppelt aufgerufen wird.
                </div>
                <div style={{display: "flex", margin: "auto", verticalAlign: "middle", alignItems: "center", marginBottom: 10}}>
                    <span style={{width: 150}}>SpielerId - Doppel:</span>
                    {spielerIdDoppel !== undefined ? <>
                            {spielerIdDoppel}
                            <Button icon="pi pi-trash" style={{marginLeft: 10}}
                                    onClick={() => setSpielerIdDoppel(undefined)}/>
                        </>
                        :
                        <Button label="Doppel auswählen" icon="pi pi-search-plus"
                                onClick={() => {
                                    setShowDoppeltTournamentSearchDialog(true);
                                }}/>
                    }
                </div>
                <hr/>
            </div>}
            {isLigaspieltag() &&
                <div className="grid">
                    <div className="col-fixed"
                         style={{width: 150}}>Spieler der Heimmanschaft:
                    </div>
                    <div className="col">
                        <ToggleButton style={{width: 200}} checked={heimmannschaft} offLabel="Nein" onLabel="Ja"
                                      onChange={(e) => setHeimmannschaft(!heimmannschaft)}/>
                    </div>
                </div>
            }
            {isKratzerTurnier() &&
                <div className="grid">
                    <div className="col-fixed"
                         style={{width: 150}}>Kratzer Gruppe:
                    </div>
                    <div className="col">
                        <DHSelectionComponent title="Kratzer" disabled={false} value={kratzerPointId} onChange={(id) => setKratzerPointId(id)}
                                              values={getKratzerPointValues()}/>
                    </div>
                </div>
            }
        </>
    }

    const getKratzerPointValues = () => {
        let auswahl = [];
        auswahl.push({name: 'Auswahl löschen', code: undefined});
        for (const k of kratzerPoints) {
            auswahl.push({name: k.bezeichnung + " (Punkte: " + k.punkte + ")", code: k.id})
        }
        return auswahl;
    }

    return <DHDialog title="Spieler anlegen/bearbeiten" showCloseButton={true}
                     onClose={() => onClose()} comp={<>
        <ErrorInfoComponent infoMessage={infoMessage} errorMessage={errorMessage} onClearInfoMessage={() => setInfoMessage(undefined)} onClearErrorMessage={() => setErrorMessage(undefined)}/>
        <Fieldset legend="Wichtiger Hinweis" toggleable={true} collapsed={true} style={{marginBottom: 20}}>
        <h4>Hinweis: Solltest du die automatische Boardvergabe nutzen wollen, ist es wichtig, dass in evtl. gleichzeitig laufenden Turnieren mit gleichen Teilnehmern der technisch gleiche
                Spieler genutzt wird. Damit wird verhindert, dass der Spieler in mehreren Turnieren gleichzeitig spielen muss. Erfasse somit den Spieler nur von Hand, wenn er noch nicht in einem
                anderen Turnier spielt. Sofern er in einem anderen Turnier bereits angemeldet ist, suche diesen Spieler über den 'Vorhandenen Spieler...' Button und füge ihn darüber hinzu. Dies
                ist ebenfalls bei Ranglisten notwendig, da die einzelnen Punkte der einzelnen Turniere über diese SpielerId zusammengefügt werden.</h4>
            <h4>Sofern du den Spieler immer mit der SpielerId erfasst, ist dies natürlich ebenfalls ok.</h4>
        </Fieldset>
        <div className="grid">
            <div className="col-12 md:col-12 lg:col-4" style={{padding: 10, borderRight:"1px solid gray"}}>
                {getNewPlayerArea()}
            </div>
            <div className="col-12 md:col-12 lg:col-8" style={{padding: 10}}>
                {getPlayersArea()}
            </div>
        </div>
        {showDoppeltTournamentSearchDialog && <TournamentPlayerEventOperatorSelectDialog
            showDoppelplayers={true}
            showEinzeltplayers={false}
            eventOperatorId={tournament.eventOperatorId}
            callBackOnClose={() => setShowDoppeltTournamentSearchDialog(false)}
            callBackOnSelect={(spielerId) => {
                setSpielerIdDoppel(spielerId);
                setShowDoppeltTournamentSearchDialog(false);
            }}/>
        }
        {showSearchDialogFuerSpielerIdSingle1 &&
            <TournamentPlayerEventOperatorSelectDialog
                eventOperatorId={tournament.eventOperatorId}
                showEinzeltplayers={true}
                showDoppelplayers={false}
                callBackOnClose={() => setShowSearchDialogFuerSpielerIdSingle1(false)}
                callBackOnSelect={(spielerId) => {
                        setSpielerIdSingle1(spielerId);
                        setShowSearchDialogFuerSpielerIdSingle1(false);
                }}/>
        }
        {showSearchDialogFuerSpielerIdSingle2 &&
            <TournamentPlayerEventOperatorSelectDialog
                eventOperatorId={tournament.eventOperatorId}
                showEinzeltplayers={true}
                showDoppelplayers={false}
                callBackOnClose={() => setShowSearchDialogFuerSpielerIdSingle2(false)}
                callBackOnSelect={(spielerId) => {
                    setSpielerIdSingle2(spielerId);
                    setShowSearchDialogFuerSpielerIdSingle2(false);
                }}/>
        }
        {showSearchDialog && <TournamentPlayerEventOperatorSelectDialog
            eventOperatorId={tournament.eventOperatorId}
            showEinzeltplayers={!tournament.doppelturnier || tournament.dyp}
            showDoppelplayers={tournament.doppelturnier && !tournament.dyp}
            callBackOnClose={() => setShowSearchDialog(false)}
            callBackOnSelect={(spielerId) => {
                setSpielerid(spielerId);
                setEingabe("");
                setSelectedPlayer(undefined);
                setKratzerPointId(undefined);
                setBezahlt(false);
                setAnwesend(false);
                setShowSearchDialog(false);
            }}/>
        }
        {showDeleteDialog &&
            <ConfirmDialog visible={true}
                           callBackOnNein={() => setShowDeleteDialog(false)}
                           callBackOnJa={() => deletePlayer()}
                           header="Spieler löschen"
                           textOben=""
                           textUnten="Möchtest du den Spieler wirklich löschen?"/>
        }
    </>}/>
}